module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_heading-917ac9b035a9908841fd98def38969a4.png";